export const SHARED_INPUT_CSS_CLASSES =
	' rounded py-2 px-2 lg:px-3 text-grey-darker ';
